module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_SE-eb114a54c3a840958371694a67d70863.svg";